import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flush", "onOpenChange", "showCloseButton", "children"];
import styled from 'foundations-theming/utils';
import { usePopoverContext } from './PopoverContext';
import { syntheticEvent } from '../../utils/SyntheticEvent/SyntheticEvent';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { StyledText } from '../../../components/Text/Text';
import { PopoverCloseButton } from './PopoverCloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledPopoverHeader = styled.header.withConfig({
  displayName: "PopoverHeader__StyledPopoverHeader",
  componentId: "jj8ne5-0"
})(({
  $flush,
  $use,
  $cssStyles,
  theme
}) => {
  return Object.assign({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    backgroundColor: $use === 'shepherd' ? theme.color['fill-accent-purple-default'] : 'inherit',
    borderStartStartRadius: 'inherit',
    borderStartEndRadius: 'inherit',
    borderEndEndRadius: theme.borderRadius['0'],
    borderEndStartRadius: theme.borderRadius['0'],
    paddingBlockStart: $flush ? theme.space['0'] : $use === 'longform' ? theme.space['500'] : $use === 'shepherd' ? theme.space['400'] : theme.space['500'],
    paddingInlineEnd: $flush ? theme.space['0'] : $use === 'longform' ? theme.space['500'] : $use === 'shepherd' ? theme.space['600'] : theme.space['600'],
    paddingBlockEnd: $flush ? theme.space['0'] : $use === 'longform' ? theme.space['0'] : $use === 'shepherd' ? theme.space['400'] : theme.space['0'],
    paddingInlineStart: $flush ? theme.space['0'] : $use === 'longform' ? theme.space['500'] : $use === 'shepherd' ? theme.space['600'] : theme.space['600']
  }, $use === 'shepherd' ? {
    color: theme.color['text-core-on-fill-default'],
    borderStartStartRadius: 'inherit',
    borderStartEndRadius: 'inherit',
    [`& ${StyledText}`]: {
      color: theme.color['text-core-on-fill-default']
    }
  } : undefined, $cssStyles, {
    [`& h1, & h2, & h3, & h4, & h5, & h6, & h1${StyledText}, & h2${StyledText}, & h3${StyledText}, & h4${StyledText}, & h5${StyledText}, & h6${StyledText}`]: Object.assign({
      marginBlockEnd: theme.space['0']
    }, $use === 'longform' ? {
      fontSize: theme.typography['heading-100'].fontSize,
      textTransform: 'none',
      marginBlockEnd: theme.space['200']
    } : undefined)
  });
});
export const PopoverHeader = _ref => {
  let {
      flush = false,
      onOpenChange,
      showCloseButton = false,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const popoverContext = usePopoverContext();
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(StyledPopoverHeader, Object.assign({}, domProps, {
    $use: popoverContext.use,
    $flush: flush,
    $cssStyles: cssStyles,
    children: [children, showCloseButton && /*#__PURE__*/_jsx(PopoverCloseButton, {
      popoverUse: popoverContext.use,
      onClick: () => {
        if (onOpenChange) onOpenChange(syntheticEvent(false));
      }
    })]
  }));
};